<template>
  <div class="swiper-container">
    <div class="swiper-content">
      <el-carousel :interval="5000" arrow="never" indicator-position="none" type="card" :height="carouselHeight + 'px'" :autoplay="true">
        <el-carousel-item v-for="(item,index) in data" :key="index">
          <div class="swiper-img" :style="{ backgroundImage: `url(${item.carouselImg})` }"></div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return [
          {
            carouselImg: require('@/assets/images/banner0.jpg')
          }
        ]
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      loading: true,
      partnerImg: [],
      carouselHeight: 730,
      
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  },
  mounted() {
    let winHeight = document.documentElement.clientHeight || document.body.clientHeight || 700
    this.carouselHeight = winHeight - 70
    console.log(winHeight)
  }
};
</script>

<style lang="scss" scoped>
.swiper-container {
  width: 100%;
  // height: 826px;
  min-height: 600px;
  position: relative;
  overflow: hidden;
  .swiper-content {
    position: relative;
    left: 50%;
    // width: 2400px;
    width: calc(150vw);
    transform: translateX(-50%);
  }
  .swiper-img {
    // height: 800px;
    height: calc(100vh - 70px);
    min-height: 574px;
    background: no-repeat center;
    background-size: cover;
  }
}
</style>